$(document).ready(function(){
	console.log('Hello World!');

	check_agb();
});


function check_agb() {
	$('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"], .additional-checkout-buttons', function(event) {
		if ($('#agree').is(':checked') || $('#agree--modal').is(':checked')) {
			$(this).submit();
		}
		else {
			event.preventDefault();

			try {


				if ($("#cart_form").length) {
					$("#cart_form")[0].reportValidity();
				}
				else {
					$("#cart_form--modal")[0].reportValidity();
				}
			}
			catch(e) {
				alert('Bitte bestätige unsere AGB und die Wiederrufsbelehrung.');
			}
			finally {
				return false;
			}
		}
	});

	// $('#agree').on('change', function(){
	// 	if ($('#agree').prop('checked')) {
	// 		$('.additional-checkout-buttons').addClass('enabled');
	// 	}
	// 	else {
	// 		$('.additional-checkout-buttons').removeClass('enabled');
	// 	}
	// });
}
